import React, { useEffect, useState } from "react";
import { Spinner, Table } from "react-bootstrap";
import UseToggle from "../../../../Hooks/UseToggle";
import SplitPane from "react-split-pane";
import EmailList from "./EmailList";
import DatasetsList from "./DatasetsList";
import TransferActivities from "./TransferActivities";
import AddPeriod from "./AddPeriod";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import UpdatePeriod from "./UpdatePeriod";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";
import { useParams } from "react-router";
import Pagination from "../../../Pagination";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Moment from "react-moment";
import Swal from "sweetalert2";

const TransferedListsetList = ({ onMouseDown, tableRef }) => {
  const { toggle2, setToggle2, toggle3, setToggle3 } = UseToggle();
  const [transferId, setTransferId] = useState("");
  const [transferedData, setTransferedData] = useState("");
  const [transferedList, setTransferedList] = useState([]);
  const [transferedCount, setTransferedCount] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [activeTab, setActiveTab] = useState("emails");
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(transferedCount / itemsPerPage);

  const getStudyDataTransfered = async () => {
    setLoading(true)
    let data = await studyDatasetsServices.getStudyDataTransfered(
      "active",
      studyId,
      pageNumber,
      itemsPerPage
    )
    setTransferedList(data?.data || []);
    setTransferedCount(data?.count || 0);
    setLoading(false)
  }

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    getStudyDataTransfered();
  }, [pageNumber, itemsPerPage]);

  const deleteStudyAIDatasetTransferData = async (transferId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete this Period!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.transferId = transferId
        userData.studyId = studyId
        let data = await studyDatasetsServices.deleteStudyAIDatasetTransferData(userData);
        if (data?.statusCode === 200) {
          getStudyDataTransfered();
        }
      }
    });
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i
            title={"Add Emails for Transfer"}
            className={`fa-solid fa-plus-square CP }`}
            onClick={() => setToggle2()}
          />
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={transferId ? "40%" : "100%"}
      >
        {loading ? (
          <PageLoader/>
        ) : transferedCount === 0 ? (
          <NoDataFoundTable MSG="History not found" />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Transfer Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Date for transfer</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Time for transfer</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Period</th>
                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Logout Time</th>
                  <th onMouseDown={(e) => onMouseDown(e, 6)}>
                    Last Updated Date |  Time
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 7)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Edit
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 8)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {transferedList?.map((item, index) => (
                  <tr key={index} className={`CP ${transferId === item?.transferId && "selectedMenu"}`}>
                    <td onClick={() => setTransferId(item?.transferId)} className="text-center">{index + 1 + startIndex}</td>
                    <td onClick={() => setTransferId(item?.transferId)}>{item?.transferId}</td>
                    <td onClick={() => setTransferId(item?.transferId)}>{item?.transferDate}</td>
                    <td onClick={() => setTransferId(item?.transferId)}>{item?.transferTime}</td>
                    <td onClick={() => setTransferId(item?.transferId)}>{item?.period} {item?.period > 1 ? "Day's" : "Day"}</td>
                    <td onClick={() => setTransferId(item?.transferId)}>{item?.timer} {item?.timer > 1 ? "Minutes" : "Minute"}</td>
                    <td onClick={() => setTransferId(item?.transferId)}>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.updatedAt}
                      </Moment>
                    </td>
                    <td className="text-center" title="Update" onClick={() => { setTransferedData(item); setToggle3() }}><FaEdit /></td>
                    <td
                      onClick={() => deleteStudyAIDatasetTransferData(item?.transferId)}
                      className="text-center" title="Delete">
                      <FaTrash className="text-danger" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={transferedCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
        {transferId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["emails", "datasets", "activities"].map((tab) => (
                  <button
                    key={tab}
                    className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                      }`}
                    onClick={() => setActiveTab(tab)}
                    title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setTransferId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "emails" && (
              <EmailList transferId={transferId} onMouseDown={onMouseDown} tableRef={tableRef} />
            )}
            {activeTab === "datasets" && (
              <DatasetsList transferId={transferId} onMouseDown={onMouseDown} tableRef={tableRef} />
            )}
            {activeTab === "activities" && (
              <TransferActivities transferId={transferId} onMouseDown={onMouseDown} tableRef={tableRef} />
            )}
          </div>
        )}
      </SplitPane>
      <AddPeriod
        Show={!toggle2}
        Hide={setToggle2}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Title={"Add New Period"}
        getStudyDataTransfered={getStudyDataTransfered}
      />
      <UpdatePeriod
        Show={!toggle3}
        Hide={setToggle3}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Title={"Update Period"}
        transferedData={transferedData}
        setTransferedData={setTransferedData}
        getStudyDataTransfered={getStudyDataTransfered}
      />
    </>
  );
};

export default TransferedListsetList;
